/* eslint-disable operator-linebreak */
/**
 * Errors
 */
// TODO: better naming convention for errors
export const IMPOSSIBLE_TRIP =
  '"Trip plan not found: requesting directions from maps.google failed. status = ZERO_RESULTS"';
export const NOT_SINGLE_REGION =
  '"Trip plan not found: given path does not belong to single region"';
export const NOT_FOUND_DISTANCE = '"Trip plan not found: \'distance\'"';
export const NOT_FOUND_UNICODE =
  '"Trip plan not found: Expected String or Unicode"';
export const DIVISION_BY_ZERO = '"Trip plan not found: division by zero"';

/**
 * Superchargers
 */
export const SUPERCHARGER_MARKER = 'supercharger';
export const NO_SUPERCHARGER_FLAG = 'no path found via supercharger';

/**
 * Easter Egg
 */
export const RED_PLANET = 'Mars';
export const EASTER_EGG_ADDRESS = 'Rocket Rd, Hawthorne, CA 90250, USA';
export const DEST = 999;
export const BFR = 'BFR';

/**
 * Destination Chargers
 */
export const DESTINATION_CHARGER_MARKER = 'destinationcharger';
export const DESTINATION_CHARGER_RADIUS = 20;
export const DESTINATION_CHARGER_UNIT = 'MI'; // or 'KM'

/**
 * DOM nodes
 */
export const AUTOCOMPLETE = 'autocomplete';
export const AUTOCOMPLETE_SELECTED = 'autocomplete--selected';
export const DRAGGABLE_DIRECTIONS = 'draggable-directions';
export const DRAGGABLE_DESTINATION_CHARGERS = 'draggable-destination-chargers';
export const VEHICLE_SELECTOR = 'vehicle-selector';
export const VEHICLE_SELECTOR_HEIGHT = 65;
export const ROUTE = 'route';
export const ROUTE_SUMMARY_HEIGHT = 147;
export const ROUTE_MOBILE = 'route--mobile';
export const PLACES = 'places';
export const PLACES_FIELD = 'tsla-form-text--map';
export const TSLA_HEADER_MAIN = 'tds-header-main';
export const TOOLTIP = 'tsla-twotip__body';
export const DIRECTIONS_LISTENER = 'directions__listener';
export const DONE_BTN = 'vehicle-selector__disclaimer';
export const MARKER = 'bfr';
export const SIDEBAR_CONTAINER = 'sidebar__container';
export const SIDEBAR_WIDTH = 370;
export const INFO_WINDOW = 'info-window';

/**
 * Analytics
 */
export const NO_ADDRESS = 'NO_ADDRESS';
export const NO_SUPERCHARGERS = 'NO_SUPERCHARGERS';
export const OUT_OF_RANGE = 'OUT_OF_RANGE';
export const IMPOSSIBLE = 'IMPOSSIBLE';
export const SUPERCHARGER = 'supercharger';
export const DESTINATION_CHARGER = 'nearby_destination_charging';
export const MAP = 'map';
export const LIST = 'list';
export const CLICK = 'click';

// Image asset url
export const RESOURCE_BASE_URL =
  process.env.NODE_ENV !== 'development' ? window.tesla.resourceBaseUrl : '';

// Configs
export const MAP_INITIAL_ZOOM = 5;
export const HOME = true; // TODO: When do we want to show the easter egg?
// TODO: Move when API calls moved to burst app.
export const API = {
  directions: {
    path: '/trips-api/route',
  },
  allSuperchargers: {
    path: '/trips-api/superchargers',
  },
  chargerDetails: '/trips-api/supercharger',
  destinationChargers: {
    path: '/trips-api/destination-chargers',
  },
  gasSavings: '/trips-api/incentives',
};
